import { cn } from '@/lib/cn'
import { shortOfferLabel } from '@shared/offers'
import type { OfferTerms } from '@shared/offers'

/**
 * Rabattens storlek som gul bricka mot blått – häftets tydligaste signal och
 * det första ögat söker efter när man bläddrar.
 */
export function OfferValue({
  terms,
  size = 'md',
  muted,
}: {
  terms: OfferTerms
  size?: 'md' | 'lg'
  muted?: boolean
}) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-2xl font-display font-extrabold',
        'leading-none tracking-tight',
        muted ? 'bg-surface-2 text-faint' : 'bg-brand text-accent',
        size === 'lg' ? 'min-w-24 px-4 py-3 text-2xl' : 'min-w-16 px-3 py-2.5 text-base',
      )}
    >
      {shortOfferLabel(terms)}
    </span>
  )
}
